export const capitalize = (term) => `${term.substring(0, 1).toUpperCase()}${term.substring(1)}`;
